export default __webpack_public_path__ + "a5adf25888a28edfe0510c7349f13d19.svg";